import type { NumericPoint } from "@incytestudios/ddv";

export const isFinitePoint = ({ x, y }: NumericPoint): boolean =>
  isFinite(x) && isFinite(y);
export const isNaturalPoint = ({ x, y }: NumericPoint): boolean =>
  y > 0 && x > 0;
export const isNaturalXPoint = ({ x }: NumericPoint): boolean => x > 0;
export const isNaturalYPoint = ({ y }: NumericPoint): boolean => y > 0;
